import { Route, Routes } from 'react-router-dom'
import ErrorBoundaryComponent from '@/components/ErrorBoundaryComponent/ErrorBoundaryComponent'
import InSpectionReport from './InspectionReport/InSpectionReport'
import ListInspection from './Inspection/ListInspection/ListInspection'
import QSFLandingPage from './QSFLandingPage/QSFLandingPage'

export default function QSFRoute() {
  return (
    <ErrorBoundaryComponent>
      <Routes>
        <Route path="" element={<QSFLandingPage />}>
          <Route path="inspection" element={<ListInspection />} />
        </Route>
        <Route path="report/:key" element={<InSpectionReport />} />
      </Routes>
    </ErrorBoundaryComponent>
  )
}
